import { Mail } from 'lucide-react';

import { NodeShell } from './NodeShell';

interface SendEmailNodeData {
  label: string;
  to?: string;
}

export const SendEmailNode = ({
  data,
  selected,
}: {
  data: SendEmailNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="send_email"
    icon={<Mail size={16} />}
    label={data.label}
    subtitle={data.to ? `To: ${data.to}` : undefined}
    selected={selected}
  />
);
